<template>
  <b-container>
    <b-row class="justify-content-md-center">
      <b-col col lg="12">
        <h1 ref="myHeader">Create a Project</h1>

        <b-alert variant="info" role="status" :show="isLoading">Loading...</b-alert>
        <b-alert variant="danger" role="alert" :show="!!error" dismissible>
          <font-awesome-icon icon="exclamation-triangle"/>
          {{ error }}
        </b-alert>

        <ProjectForm
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :values="item"
          @item-changed="onItemChange"
          :project-errors="violations"
          :publish-button-title="publishButtonTitle"
          :draft-button-title="draftButtonTitle"
          :is-loading="isLoading"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import ProjectForm from '../project/Form.vue';

export default {
  components: {
    ProjectForm
  },

  provide() {
    return {parentValidator: this.$validator}
  },

  data() {
    return {
      item: {
        projectState: null,
        approveContacts: true,
        isPrivate: false,
        isSciStarter: false,
        isZooniverse: false,
        isAirtable: false,
        picture: null,
        bannerPicture: null,
        organizations: []
      },
      publishButtonTitle: 'Publish Project',
      draftButtonTitle: 'Save As Draft'
    }
  },

  created() {
    this.$validator.validateAll()
  },

  computed: {
    ...mapGetters({
      isLoading: 'project/create/isLoading',
      error: 'project/create/error',
      created: 'project/create/created',
      violations: 'project/create/violations',
    }),
  },

  watch: {
    created(newVal) {
      if (!newVal) {
        return
      }

      this.$router.push({name: 'ProjectShow', params: {id: newVal['urlField']}})
    },

    error(newVal) {
      if (newVal && newVal.length > 0 && newVal.toLowerCase().indexOf('validate') !== -1) {
        this.$refs.myHeader.scrollIntoView({behavior: "smooth", block: "end", inline: "start"});
      }
    }
  },

  methods: {
    ...mapActions({
      create: 'project/create/create',
    }),

    onItemChange(data) {
      Object.assign(this.item, data)
    },

    onSendForm(item, orgRequests, isDraft) {
      // On button press run validation and then create project
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            this.item.latitude = parseFloat(this.item.latitude);
            this.item.longitude = parseFloat(this.item.longitude);

            // Project state is set to published | draft
            this.item.projectState = isDraft ? this.PROJECT_STATE_DRAFT : this.PROJECT_STATE_PUBLISHED;
            this.create({projectData: this.item, organizations: orgRequests})
          } else {
            this.$el.getElementsByClassName('is-invalid')[0].parentElement.parentElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
          }
        })
    },

    updateField(field, value) {
      Object.assign(this.item, {[field]: value})
    }
  },
}

</script>

<style lang="scss" scoped>

</style>
